import { useMutation } from '@apollo/client';
import { showNotification } from '@utils/helpers/notifications';
import { useEffect, useState } from 'react';

const useCreateUpdateRecord = ({
  mutation,
  formData,
  callback,
  isDelete,
  variables = {},
  buildVariables,
  onResponse,
}) => {
  const [data, setData] = useState(null);
  const [createUpdateRequest, { loading }] = useMutation(mutation);

  useEffect(() => {
    const sendRequest = async () => {
      try {
        let props = {
          ...variables,
        };

        if (buildVariables) {
          props = buildVariables({ formData, variables, isDelete });
        } else if (!isDelete) {
          props = {
            ...variables,
            data: formData,
          };
        }

        const { data } = await createUpdateRequest({
          variables: {
            ...props,
          },
        });

        setData(data);

        const shouldSkipDefaultHandling = onResponse ? await onResponse(data) : false;
        if (shouldSkipDefaultHandling) {
          return;
        }

        if (data.success) {
          showNotification('success', 'Success', data.message);

          if (callback) {
            callback(data?.result);
          }
        } else {
          showNotification('error', 'Error', data.message);
        }
      } catch (error) {
        showNotification('error', 'Error', error.message);
      }
    };
    if (formData) {
      sendRequest();
    }
  }, [formData]);

  return { data, loading };
};

export default useCreateUpdateRecord;
